import { render } from "./DistrictMenuComponent.vue?vue&type=template&id=5f8ec0ea&scoped=true"
import script from "./DistrictMenuComponent.vue?vue&type=script&lang=js"
export * from "./DistrictMenuComponent.vue?vue&type=script&lang=js"

import "./DistrictMenuComponent.vue?vue&type=style&index=0&id=5f8ec0ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8ec0ea"]])

export default __exports__